import * as React from "react"
import { Row } from "react-grid-system"
import Subtitle from "../../atoms/typography/Subtitle"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"
import H3 from "../../atoms/typography/H3"
import { theme } from "../../../components/theme"
import { useOtpLogin } from "../../../hooks/useOtpLogin"
import { HorizontalSpacer, Spacer } from "../../atoms/spacers"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"
import LoadingSpinner from "../../atoms/LoadingSpinner"
import SecondaryButton from "../../atoms/buttons/SecondaryButton"
import TextInput from "../../molecules/TextInput"
import { ApolloError } from "@apollo/client"
import { captureExceptionWithContext } from "../../../utils/sentry"

const Content = styled.div`
  padding: 2rem 3rem;
  width: 40vw;

  ${MediaQuery.SM} {
    width: 40vw;
  }

  ${MediaQuery.XS} {
    width: 90vw;
    padding: 1rem;
  }
`

interface Props {
  onClickGoBack: () => void
  onCloseModal: () => void
  redirectUrl?: string
}

const BackupTokenCard: React.FunctionComponent<Props> = ({ onClickGoBack, onCloseModal, redirectUrl }) => {
  const [token, setToken] = React.useState("")

  const handleTokenInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newInputValue = e.target.value.replace(/[^a-zA-Z0-9]/g, "")
    setToken(newInputValue)
  }

  const onCompletedBackupLogIn = (data: any) => {
    if (data?.totpLogin?.success) {
      onCloseModal()
      if (redirectUrl) {
        window.location.href = redirectUrl
      }
    }
  }
  const onErrorBackupLogIn = (apolloError: ApolloError) => {
    captureExceptionWithContext(apolloError, "Error in backup login")
  }
  const { otpLogin, data, loading } = useOtpLogin({
    onCompleted: (data: any) => onCompletedBackupLogIn(data),
    onError: onErrorBackupLogIn,
  })
  const onSubmitToken = async () => {
    try {
      await otpLogin({
        variables: {
          backupToken: token,
        },
      })
    } catch (error) {
      captureExceptionWithContext(error, "Error in backup login")
    }
  }
  const onClickBackOutOfBackup = async () => {
    try {
      await otpLogin({
        variables: {
          goBack: true,
        },
      })
    } catch (error) {
      captureExceptionWithContext(error, "Error in backup login")
    }
  }

  const onGoBack = () => {
    onClickBackOutOfBackup()
    onClickGoBack()
  }

  return (
    <Row justify="center">
      <Content>
        <HorizontalSpacer spacing={1} />
        <Subtitle textAlign="center">Two factor authenication</Subtitle>
        <HorizontalSpacer spacing={3} />
        <TextInput textFieldTitle="Backup token" value={token} onChange={handleTokenInputChange} type="text" />
        <HorizontalSpacer spacing={3} />

        {data?.totpLogin?.errors?.length > 0 && (
          <div>
            <HorizontalSpacer spacing={1} />
            <H3 color={theme.colors.red}>{data.totpLogin.errors}</H3>
          </div>
        )}
        <HorizontalSpacer spacing={3} />
        <Row justify="center">
          <PrimaryButton title="Cancel" onClick={onGoBack} />
          <Spacer spacing={2} />
          {loading ? (
            <LoadingSpinner />
          ) : (
            <SecondaryButton title="Verify code" onClick={onSubmitToken} disabled={token.length < 1} />
          )}
        </Row>
        <HorizontalSpacer spacing={1} />
      </Content>
    </Row>
  )
}

export default BackupTokenCard
